import { render, staticRenderFns } from "./resetPasswordDialog.vue?vue&type=template&id=7373efa8&scoped=true&"
import script from "./resetPasswordDialog.vue?vue&type=script&lang=ts&"
export * from "./resetPasswordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./resetPasswordDialog.vue?vue&type=style&index=0&id=7373efa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373efa8",
  null
  
)

export default component.exports